import { Container } from "react-bootstrap";
import "./App.scss";
import { NavBar } from "./components/NavBar/NavBar";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect } from "react";
import { DataContex } from "./context/DataContext";
import { CarteleraPage } from "./components/pages/CarteleraPage";
import { MaterialesPage } from "./components/pages/MaterialesPage";
import { RepertorioPage } from "./components/pages/RepertorioPage";
import { Footer } from "./components/Footer/Footer";
import { brandCajaH } from "./assets";
import { ContactoPage } from "./components/pages/ContactoPage";
import { ObraInfo } from "./components/Repertorio/ObraInfo";
import { NosotrosPage } from "./components/pages/NosotrosPage";
import { PublicacionesPage } from "./components/pages/PublicacionesPage";
import { MaterialABM, MaterialABMNew } from "./components";
import { EditMaterial } from "./components/MaterialEdit/EditMaterial";
import { MaterialCreate } from "./components/MaterialCreate/MaterialCreate";
import { HomePage } from "./components/pages/HomePage";
import { Prensa } from "./components/pages/Prensa";
import { WhatsAppButtonFloat } from "./components/WhatsAppButton/WhatsAppFloatButton";
import RepertorioPorTema from "./components/Repertorio/RepertorioPorTema";
import { DiarioDeMarcha } from "./components/pages/DiarioDeMarcha";
import { CalculadorDeFuncion } from "./components/pages/CalculadorDeFuncion";
import { ListadoMateriales } from "./components/pages/ListadoMateriales";
import { CrosswordPage } from "./components/pages/CrosswordPage";
import { ABMUsuarios } from './components/ABMUsuarios/ABMUsuarios';
import { ProtectedRoute } from "./components/ProtectedRoute/ProtectedRoute";
import { useUser } from "./hooks/useUser";
import { NivelRoutes } from "./components/ProtectedRoute/NivelRoutes";
import { Perfil } from "./components/pages/Perfil";
import { LogInPage } from "./components/pages/LogInPage";
import { ConfiguracionEstructuraEducativa } from "./components";

// Componente para limpiar URLs
const URLCleaner = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Si hay parámetros de consulta, redirigir a la URL limpia
    if (location.search) {
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate]);

  return children;
};

function App() {
  const { paths, dataSource } = useContext(DataContex);
  const { loading } = useUser();

  const {
    cartelera,
    home,
    obras,
    materiales,
    contacto,
    nosotros,
    publicaciones,
    editMaterial,
    materialCreate,
    abm,
    prensa,
    diarioDeMarcha,
    calculador
  } = paths;

  if (loading) {
    return (
      <Container fluid className='App'>
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
        </div>
      </Container>
    );
  }

  return (
    <Container fluid className='App'>
      <URLCleaner>
        <NavBar brand={brandCajaH} expand={"lg"} />
        <Routes>
          {/* Rutas públicas */}
          <Route path='/' element={<HomePage />} />
          <Route path={home} element={<HomePage />} />
          <Route path={cartelera} element={<CarteleraPage />} />
          <Route path={materiales} element={<MaterialesPage />} />
          <Route path={publicaciones} element={<PublicacionesPage />} />
          <Route path={obras} element={<RepertorioPage />} />
          <Route path={contacto} element={<ContactoPage />} />
          <Route path={nosotros} element={<NosotrosPage />} />
          <Route path={prensa} element={<Prensa />} />
          <Route path="/login" element={<LogInPage />} />
          <Route path={`${obras}/tema/:tema`} element={<RepertorioPorTema />} />
          <Route path={'/listado-materiales'} element={<ListadoMateriales />} />
          <Route path={"/crucigramas"} element={<CrosswordPage />} />
          <Route path={diarioDeMarcha} element={<DiarioDeMarcha />} />
          <Route path={'/colegio'} element={<ConfiguracionEstructuraEducativa />} />
          <Route path="/perfil" element={
            <ProtectedRoute>
              <Perfil />
            </ProtectedRoute>
          } />
          
          {/* Rutas protegidas */}

          <Route element={<NivelRoutes nivel={9} />}>
            <Route path={abm} element={<MaterialABM />} />
            <Route path={'/abmNew'} element={<MaterialABMNew />} />
            <Route path="/abm-usuarios" element={<ABMUsuarios />} />
            <Route path={materialCreate} element={<MaterialCreate />} />
            <Route path={`${editMaterial}/:id`} element={<EditMaterial />} />
          </Route>

          <Route path={calculador} element={<CalculadorDeFuncion />} />
          
          {/* Rutas de obras */}
          {Array.from(dataSource).map((obra, id) => (
            <Route
              key={id}
              path={`${obras}/${obra.ID}`}
              element={<ObraInfo obra={obra} />}
            />
          ))}
          
          {/* Ruta por defecto */}
          <Route path='/*' element={<Navigate to={paths.home} replace />} />
        </Routes>
        <Footer />
        <WhatsAppButtonFloat />
      </URLCleaner>
    </Container>
  );
}

export default App;

//http://localhost:3000/static/media/aldeaPortada.f4ba853de677786dc5d8.webp
